import axios from 'axios';

export const envsMixin = {
    data() {
        return {
            urlBase: process.env.VUE_APP_API_URL_ZEBRA,
            urlApi: process.env.VUE_APP_API_URL,
            wompiPub: process.env.VUE_APP_WOMPIPUB,
            wompi_url: process.env.VUE_APP_WOMPI_URL,
            apiOptions: {
                headers: {
                    language: 'spa', 
                    token: '',
                    'Content-Type': 'application/json' 
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        saveTransaccion(params) {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlBase}saveTransaccion`, params)
                    .then(({data}) => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        
        getMerchants() {
            return new Promise((response, reject) => {
                let self = this;
                axios.get(`${self.wompi_url}/merchants/${self.wompiPub}`)
                    .then(({data}) => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        getTransaction(transactionId) {
            return new Promise((response, reject) => {
                let self = this;                
                axios.get(`${self.urlBase}transactions/${transactionId}`)
                    .then(({data}) => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        getInstitucionesFinancieras() {
            return new Promise((response, reject) => {
                let self = this;                
                axios.post(`${self.urlBase}wompi/financial_institutions`, {}, self.apiOptions)
                    .then(({data}) => {
                        response(data.data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        async postCardToken(cardData) {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlBase}wompi/tokenCard`, {cardData})
                    .then(data => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        getTRM() {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlApi}trmSuperFinanciera`, {}, self.apiOptions)
                    .then(({data}) => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        get(path) {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlBase}zebra`, {url: path, method: "get"}, self.apiOptions)
                    .then(({data}) => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        post(path, params) {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlBase}zebra`, {url: path, method: "post", data: params}, self.apiOptions)
                    .then(data => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        postTransaction(params) {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlBase}wompi/transaction`, params, self.apiOptions)
                    .then(data => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        dataJsonTransaccional(params) {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlBase}dataJsonTransaccional`, params, self.apiOptions)
                    .then(({data}) => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        enviarCotizacion(params) {
            return new Promise((response, reject) => {
                let self = this;
                axios.post(`${self.urlBase}enviarCot`, params, self.apiOptions)
                    .then(({data}) => {
                        response(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        }
    },
}
